import { render, staticRenderFns } from "./IOSSNumbersTableMobile.vue?vue&type=template&id=187434e6&scoped=true"
import script from "./IOSSNumbersTableMobile.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187434e6",
  null
  
)

export default component.exports